import PropTypes from 'prop-types';
import React, {createContext, useContext} from 'react';

import {REMOTE_CONFIG_KEYS} from '../configs/remoteConfigKeys';
import {useRemoteConfig} from '../hooks/useRemoteConfig';

export const RemoteConfigContext = createContext();

export const RemoteConfigProvider = ({children}) => {
  const remoteConfigData = useRemoteConfig([
    {key: REMOTE_CONFIG_KEYS.MAINTENANCE_MODE, type: 'boolean'},
    {key: REMOTE_CONFIG_KEYS.FEATURE_FLAGS, type: 'json'},
    {key: REMOTE_CONFIG_KEYS.RECAPTCHA_CONFIGS, type: 'json'},
    {key: REMOTE_CONFIG_KEYS.TERMS_POLICY_CONTENT, type: 'json'}
  ]);

  return (
    <RemoteConfigContext.Provider value={remoteConfigData}>
      {children}
    </RemoteConfigContext.Provider>
  );
};

export const useRemoteConfigContext = () => {
  const context = useContext(RemoteConfigContext);
  if (!context) {
    throw new Error(
      'useRemoteConfigContext deve ser usado dentro de RemoteConfigProvider'
    );
  }
  return context;
};

RemoteConfigProvider.propTypes = {
  children: PropTypes.node.isRequired
};
